import { Injectable } from '@angular/core';
import {AbstractControl} from '@angular/forms';
import {  FormGroup, FormControl } from '@angular/forms';
import { environment } from '../../environments/environment';
import { TextSetting } from '../textsetting';
import { formatDate } from '@angular/common';
declare var swal: any;
@Injectable()

export class ValidationService {
	env = environment;
	static getValidatorErrorMessage = (lang: string, name: string, validatorName: string, validatorValue?: any): any => {
		let min_number = environment.PASWORD_MIN_LENGTH;
		if (lang !== undefined && lang === 'en'){
			
			const config: any  = {
				required                 : 'Please enter '+name.toLowerCase()+' here.',
				invalidEmailAddress      : 'Please enter valid email id here.',
				invalidPassword          : `Password length should be minimum ${min_number} characters with atleast 1 capital, 1 small and 1 special character.`,
				invalidSixPassword          : `Password length should be minimum 6 characters.`,
				invalidNumber	         :	'Please enter valid phone number.  Phone number should be numeric and 10 digits long.',
				invalidText	             : 'Please enter only numeric value',
				invalidPositiveNumber    : 'Please enter only positive numeric value',
				matchPassword            : `Passwords do not match.`,
				matchEmail            	 : `Email do not match.`,				
				invalidImage             : `The image must be a type of: jpeg, jpg, png.`,
				specialCharMsg           : `This field should not contain any special character and numeric value.`,
				invalidDate              :  `Please enter valid date.`,
				alphaNumericCharMsg                : `This field should not contain any special character value.`,
				alphaNumericCharMsgOnlySalary      : `Please enter valid salary.`,
				hasWhiteSpace      : 'Please enter '+name.toLowerCase()+' here.',
			};
			return config[validatorName];
		}else{
			const config: any  = {
				required                : 'هذه الخانة مطلوبه.',
				invalidEmailAddress     : 'يرجى إدخال معرف بريد إلكتروني صالح هنا.',
				invalidPassword         : 'من فضلك أدخل كلمة سر صالحة',
				invalidSixPassword         : 'من فضلك أدخل كلمة سر صالحة',
				invalidNumber	          : 'الرجاء إدخال رقم هاتف صحيح',
				invalidText		      : 'يرجى إدخال قيمة رقمية فقط',
				matchPassword           : `كلمة المرور غير مطابقة.`,
				matchEmail            	 : `البريد الإلكتروني لا يتطابق.`,								
				invalidImage            : `The image must be a type of: jpeg, jpg, png.`,
				specialCharMsg          : `يجب ألا يحتوي هذا الحقل على أي حرف خاص وقيمة رقمية.`,
				invalidDate              : `الرجاء إدخال تاريخ صحيح.`,
				alphaNumericCharMsg      : `يجب ألا يحتوي هذا الحقل على أي قيمة شخصية خاصة.`,
				alphaNumericCharMsgOnlySalary      : `يجب ألا يحتوي هذا الحقل على أي قيمة شخصية خاصة.`,
				hasWhiteSpace      : 'هذه الخانة مطلوبه.',
			};
			return config[validatorName];
		}
	}

	static getValidatorSelectErrorMessage = (lang: string, name: string, validatorName: string, validatorValue?: any): any => {
		if (lang !== undefined && lang === 'en'){
			const config: any  = {
				required                 : 'Please select '+name.toLowerCase()+' here.',
			};
			return config[validatorName];
		}else{
			const config: any  = {
				required                : 'هذه الخانة مطلوبه.',
			};
			return config[validatorName];
		}
	}


	static getValidatorFileErrorMessage = (lang: string, name: string, validatorName: string, validatorValue?: any): any => {
		
		if (lang !== undefined && lang === 'en'){
			const config: any  = {
				required                 : 'Please upload your file here.',
			};
			return config[validatorName];
		}else{
			const config: any  = {
				required                : 'يرجى تحميل ملفك هنا.',
			};
			return config[validatorName];
		}
	}

	// Function for email validation
	static emailValidator = (control: any): any => {

		if ((typeof(control.value) === 'string') && control.value.match(/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/)) {
			return null;
		} else {
			return { invalidEmailAddress: true };
		}
	}

	// Function for special character validation
	static specialCharValidator = (control: any): any => {
		if ((typeof(control.value) === 'string') && control.value.match(/^[a-zA-Z ]+$/)) {
			return null;
		} else {
			return { specialCharMsg: true };
		}
	}

	// Function for alpa numeric validation
	static alphaNumericValidator = (control: any): any => {
		if ((typeof(control.value) === 'string') && control.value.match(/[a-zA-Z!@#$%^&*()_+\-=\[\]{}/;':"\\|,<>\?]/)) {
			return { alphaNumericCharMsg: true };
		} else {
			return null;
		}
	}

	// Function for salary numeric validation
	static alphaNumericValidatorOnlySalary = (control: any): any => {
		if ((typeof(control.value) === 'string') && control.value.match(/[a-zA-Z!@#$%^&*()_+\-=\[\]{}/;':"\\|,<>\?]/)) {
			return { alphaNumericCharMsgOnlySalary: true };
		} else {
			return null;
		}
	}
	
	// Function for white space validation
	static noWhitespaceValidator(control: FormControl) {
		if ((typeof(control.value) === 'string') && control.value.trim() == '') {
			return { hasWhiteSpace: true };
		} else {
			return null;
		}
	}
	

	// Function for the password validation
	static passwordValidator = (control: any): any => {
		let min_number = Number(environment.PASWORD_MIN_LENGTH);
		let max_number = Number(environment.PASWORD_MAX_LENGTH);
		if ((typeof(control.value) === 'string') && control.value.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,100}$/)) {
			return null;
		} else {
			return { invalidPassword: true };
		}
	}
	
	// Function for the password length validation
	static passwordSixValidator = (control: any): any => {
		if ((typeof(control.value) === 'string') && control.value.length >= 6 ) {
			return null;
		} else {
			return { invalidSixPassword: true };
		}
	}

	// Function for the mobile number validation
	static numberValidator = (control: any): any => {
		if ((typeof(control.value) === 'string') && control.value.match(/^[0-9]{10}$/)){
			return null;
		} else {
			return { invalidNumber: true };
		}
	}

	// This function are used for only numeric condition
	static numericValidator = (control: any): any => {
		if ((typeof(control.value) === 'string') && control.value.match(/^[0-9]*$/)){
			return null;
		} else {
			return { invalidText: true };
		}
	}
	
	// This function are used for only numeric and greater than 0 price condition
	static priceValidator = (control: any): any => {
		if ((typeof(control.value) === 'string') && control.value > 0  && control.value.match(/^[0-9]*$/)){ 
			return null;
		} else { 
			return { invalidText: true };
		}
	}

	// This function are used for only numeric condition
	static numericPositiveValidator = (control: any): any => {
		if (control.value.match(/^[0-9]*$/)){
			return null;
		} else {
			return { invalidPositiveNumber: true };
		}
	}

	// This function are used for only numeric condition
	static editNumericValidator = (control: any): any => {
		if (isNaN(control.value) === false ){
			return null;
		} else {
			return { invalidText: true };
		}
	}

	// Function for the match password validation
	static MatchPassword = (AC: AbstractControl): any => {
		const formGroup = AC.parent;
		if (formGroup) {
			const passwordControl = formGroup.get('password'); // to get value in input tag
			const confirmPasswordControl = formGroup.get('confirm_password'); // to get value in input tag

			if (passwordControl && confirmPasswordControl) {
				const password = passwordControl.value;
				const confirmPassword = confirmPasswordControl.value;
				if (password !== confirmPassword) {
					return { matchPassword: true };
				} else {
					return null;
				}
			}
		}
		return null;
	}

	// Function for the match email validation
	static MatchEmail = (AC: AbstractControl): any => {
		const formGroup = AC.parent;
		if (formGroup) {
			const emailControl = formGroup.get('email'); // to get value in input tag
			const confirmEmailControl = formGroup.get('confirm_email'); // to get value in input tag

			if (emailControl && confirmEmailControl) {
				const password = emailControl.value;
				const confirmEmail = confirmEmailControl.value;
				if (password !== confirmEmail) {
					return { matchEmail: true };
				} else {
					return null;
				}
			}
		}
		return null;
	}

	// Function is used to check file attachment on file change event
	static validateExt = (control: any): any => {
		const extension = ['png', 'jpeg', 'jpg'];
		return extension.indexOf(control.value) ? null : { invalidImage: true };
	}


	/*This function are used validate all fields.*/
	static	validateAllFormFields(formGroup: FormGroup) {
		Object.keys(formGroup.controls).forEach(field => {
			const control = formGroup.get(field); 
			if (control instanceof FormControl) {
				//~ var fieldValue	=	(formGroup.controls[field].value) ? formGroup.controls[field].value : '';
				var fieldValue	=	(typeof formGroup.controls[field].value === 'string') ? formGroup.controls[field].value.trim() : formGroup.controls[field].value;
				formGroup.controls[field].patchValue(fieldValue);
				control.markAsTouched({ onlySelf: true });
				/*for (let propertyName in control.errors) {
					alert(propertyName +"---"+ field);
					break;
				}*/	
			} else if (control instanceof FormGroup) {
				ValidationService.validateAllFormFields(control);

			}
		});
	}//end validateAllFormFields()


	static	onlyvalidatejob(formGroup: FormGroup) {
		Object.keys(formGroup.controls).forEach(field => {
			const control = formGroup.get(field); 
			if (control instanceof FormControl) {
				//~ var fieldValue	=	(formGroup.controls[field].value) ? formGroup.controls[field].value : '';
				var fieldValue	=	(typeof formGroup.controls[field].value === 'string') ? formGroup.controls[field].value.trim() : formGroup.controls[field].value;
				formGroup.controls[field].patchValue(fieldValue);
				control.markAsTouched({ onlySelf: true });
				/*for (let propertyName in control.errors) {
					alert(propertyName +"---"+ field);
					break;
				}*/	
			} else if (control instanceof FormGroup) {
				ValidationService.validateAllFormFields(control);

			}
		});
	}
	// This function are used validate image fields.
	static validateImageField = (files: any): any => {
		const validation: any  =   {};
		validation.status    =   false;
		validation.message   =   TextSetting.UPLOAD_IMAGE_ERROR_MSG;
		if (files.length > 0) {
			const MAX_IMAGE_SIZE_IN_MB	=	environment.MAX_FILE_UPLOAD_LIMIT;
			const UPLOAD_FILE_SIZE = MAX_IMAGE_SIZE_IN_MB; // file size in MB
			const size = files[0].size.toFixed(2);
			const allowedSize = UPLOAD_FILE_SIZE * 1024 * 1024;
			if (size > allowedSize){
				validation.status    =   false;
				validation.message   =   TextSetting.VALID_SIZE_IMAGE_ERROR_MSG + ' ' + MAX_IMAGE_SIZE_IN_MB + ' MB.';
			}else{
				validation.status    =   true;
			}
		}
		return  validation;
	}// end validateImageField()

	// This function are used validate image extensions.
	static validateImageExtension = (files: any): any => {
		const validation: any  =   {};
		validation.status    =   false;
		validation.message = "The image must be a type of: jpeg, jpg, png, svg.";
		if (files.length > 0) {
            let ALLOWED_IMAGE_EXTENTIONS = ['png', 'jpeg', 'jpg','svg'] ;
            let ext = files[0]['name'].split('.').pop();
            ext = ext.toLowerCase();

			if (ALLOWED_IMAGE_EXTENTIONS.includes(ext)) {
                validation['status'] = true;
            }else{
				validation['status'] = false;
				validation['message'] = "The image must be a type of: jpeg, jpg, png, svg.";
			}
		}
		return  validation;
	}// end validateImageField()

	// This function are used validate doc extensions.
	static validateDocExtension = (files: any): any => {
		const validation: any  =   {};
		validation.status    =   false;
		validation.message = "The document must be a type of: doc, pdf, docx.";
		if (files.length > 0) {
            let ALLOWED_IMAGE_EXTENTIONS = ['doc', 'pdf', 'docx'] ;
            let ext = files[0]['name'].split('.').pop();
            ext = ext.toLowerCase();

			if (ALLOWED_IMAGE_EXTENTIONS.includes(ext)) {
                validation['status'] = true;
            }else{
				validation['status'] = false;
				validation['message'] = "The document must be a type of: doc, pdf, docx.";
			}
		}
		return  validation;
	}// end validateImageField()


	// This function are used validate csv extension.
	static validateImportExtension = (files: any): any => {
		const validation: any  =   {};
		validation.status    =   false;
		validation.message = "The document must be a type of: csv.";
		if (files.length > 0) {
            let ALLOWED_IMAGE_EXTENTIONS = ['csv'] ;
            let ext = files[0]['name'].split('.').pop();
            ext = ext.toLowerCase();

			if (ALLOWED_IMAGE_EXTENTIONS.includes(ext)) {
                validation['status'] = true;
            }else{
				validation['status'] = false;
				validation['message'] = "The document must be a type of: csv.";
			}
		}
		return  validation;
	}// end validateImageField()


	// Function is used to open confirm poppup
	public confirm = (message: any): any => {
		return swal.fire({
			title: 'Are you sure',
			text: message,
			type: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#0183cf',
			cancelButtonColor: '#35404e',
			confirmButtonText: 'Yes'
		}).then((result: any) => {
			return result.value;
		});
	}

	// Function is used to open confirm popup
	public newConfirm = (message: any, lang: any): any => {
		return swal.fire({
			title:  (lang === 'en') ? 'Are you sure' : 'هل أنت واثق',
			text: message,
			type: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#0183cf',
			cancelButtonColor: '#35404e',
			confirmButtonText: (lang === 'en') ? 'Yes' : 'نعم',
			cancelButtonText: (lang === 'en') ? 'Cancel' : 'إلغاء',
		}).then((result: any) => {
			return result.value;
		});
	}


	// Function for the check Current Date validation
	static checkCurrentDateValidator(control: AbstractControl): { [key: string]: boolean } | null {
		if (control?.value) {
			let date = new Date()
			date.setDate(date.getDate() - 1)
			const today = date.getTime();
			let controlValueSplit = control.value.toString().split('-')
			var controlValue = new Date(controlValueSplit[1] + '/' + controlValueSplit[0] + '/' + controlValueSplit[2] + " GMT").getTime();
			if (controlValue < today) {
				return { invalidDate: true}
			}
		}
		return null;
	}


	
}
